import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import React, { useState } from "react";
import { IntendedFor } from "utils/constants";
import { IntendedForChoices } from "utils/choices"
import StudentForm from "./StudentForm";
import { Button, FunctionField, Labeled, TextField } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import StudyGroupsForm from "./StudyGroupsForm";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

const SessionExamStudent = ({ record }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const [isEditIntended, setIsEditIntended] = useState(false);
  const [isEditStudyGroups, setIsEditStudyGroups] = useState(false);

  const shouldRenderStudentFields =
    record?.intendedFor === IntendedFor.OnlyNotPastExamsStudents ||
    record?.intendedFor === IntendedFor.RegularAndNotPastExamsStudents;

  const isIntendedForIndividual = record?.intendedFor === IntendedFor.Individual;

  const handleEditClick = () => {
    setIsEditIntended(true);
  };

  const handleEditStudyGroups = () => {
    setIsEditStudyGroups(true);
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{ ...(isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox) }}
    >
      {isEditIntended ? (
        <StudentForm
          intendedFor={record.intendedFor}
          studentsCapacity={record.studentsCapacity}
          record={record}
          setIsEditIntended={setIsEditIntended}
        />
      ) : (
        <>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Предназначен за">
              <FunctionField
                render={rec => {
                  return IntendedForChoices.find((intendedForEl) => intendedForEl.id === rec.intendedFor).name
                }}
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            {record?.intendedFor === IntendedFor.Regular && null}
            {shouldRenderStudentFields &&
              (record.studentsCapacity > 0 ? (
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <Grid
                    item
                    xs={12}
                  >
                    <Labeled label="Студентски капацитет">
                      <TextField source="studentsCapacity" />
                    </Labeled>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <SecuredComponent permission={permissions.canUpdateSessionExamIntention}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<EditIcon />}
                        label="Редактирай"
                        onClick={handleEditClick}
                      />
                    </SecuredComponent>
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Grid
                    item
                    xs={12}
                  >
                    <Labeled label="От факултетен номер">
                      <TextField source="fromFacultyNumber" />
                    </Labeled>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <Labeled label="До факултетен номер">
                      <TextField source="toFacultyNumber" />
                    </Labeled>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <SecuredComponent permission={permissions.canUpdateSessionExamIntention}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<EditIcon />}
                        label="Редактирай"
                        onClick={handleEditClick}
                      />
                    </SecuredComponent>
                  </Grid>
                </>
              ))}
          </Grid>
        </>
      )}
      {isEditStudyGroups ? (
        <StudyGroupsForm
          setIsEditStudyGroups={setIsEditStudyGroups}
          record={record}
        />
      ) : (
        <Grid
          item
          xs={12}
          md={4}
        >
          <Grid
            item
            xs={12}
            sx={{ mb: 2 }}
          >
            <Labeled label="Учебни групи">
              <FunctionField render={rec => (rec?.studyGroups?.length < 1 ? "ВСИЧКИ" : rec?.studyGroups?.join(", "))} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
          >
            {!isIntendedForIndividual && (
              <SecuredComponent permission={permissions.canUpdateSessionExamStudyGroups}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<EditIcon />}
                  label="Редактирай"
                  onClick={handleEditStudyGroups}
                />
              </SecuredComponent>
            )}
          </Grid>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sx={{ mt: 2 }}
      >
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Брой редовно">
              <TextField source="enrolledRegular" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Брой от минали години">
              <TextField source="enrolledRetakers" />
            </Labeled>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SessionExamStudent;
